<template>
  <section class="promo__codes-form-wrap media-buying-modal add-public-modal">
    <Modal
      v-model:show="active"
      @close="close"
    >
      <template v-slot:header>
        <h5 class="modal-title">
          <span class="incrementing-id">(ID: {{ form.incrementing_id }})</span>
          {{ $t('mediaBuying.campaign.payment') }}
        </h5>
      </template>
      <div>
        <form>
          <div
            v-if="form.id"
            class="comment-overflow"
          >
            <div
              v-for="(comment, index) in comments"
              :key="index"
              class="comment-wrap__wrap"
            >
              <div class="comment-wrap__mess">
                <div
                  v-if="comment.author_type === 'admin'"
                  class="aff-text-left mb-8"
                >
                  <span class="comment-wrap__mess-text comment-wrap__mess-text-left">
                    <span class="date">
                      {{ $filters.formatDate3(comment.created_at) }}
                    </span>
                    <span class="comment-wrap__mess-text-row">{{ comment.content }}</span>
                    <a
                      v-for="(file, ind) in comment.files"
                      :key="ind"
                      :href="file.download_url"
                      :download="file.filename"
                      target="_blank"
                      class="comment-wrap__mess-files mb-4 mr-4"
                    >
                      <span class="file-name">{{ file.filename }}</span>
                      <i class="fas fa-download pl-4" />
                    </a>
                  </span>
                </div>
                <div
                  v-if="comment.author_type === 'affiliate'"
                  class="aff-text-right !tw-text-right mb-8"
                >
                  <span
                    :class="{ editable: editIndexComment === index }"
                    class="comment-wrap__mess-text comment-wrap__mess-text-right"
                  >
                    <span class="comment-wrap__content">
                      <span
                        v-if="hideEditAndDelete(comment)"
                        class="comment-wrap__control"
                      >
                        <span class="date">
                          {{ $filters.formatDate3(comment.created_at) }}
                        </span>
                        <i
                          v-if="editIndexComment !== index"
                          class="fas fa-pen pl-4"
                          @click="editMessage(comment, index)"
                        />
                        <i
                          v-if="editIndexComment !== index"
                          class="fas fa-times pl-4"
                          @click="deleteMessage(comment, index)"
                        />
                      </span>
                      <span class="comment-wrap__mess-text-row">{{ comment.content }}</span>
                      <a
                        v-for="(file, ind) in comment.files"
                        :key="ind"
                        :href="file.download_url"
                        :download="file.filename"
                        target="_blank"
                        class="comment-wrap__mess-files mb-4 mr-4"
                      >
                        <span class="file-name-wrap">
                          <span class="file-name">{{ file.filename }}</span>
                          <i class="fas fa-download pl-4" />
                        </span>
                      </a>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="comment-wrap__inn mt-8">
            <div class="!tw-flex comment-wrap">
              <div>
                <div class="form-group select-wrapper m-0 !tw-w-full">
                  <textarea
                    v-if="active"
                    v-model="comment"
                    :placeholder="$t('mediaBuying.campaign.comment')"
                    class="form-control form-control-ta"
                  />
                </div>
                <button
                  v-if="flagEditComment"
                  class="btn btn-outline-danger btn-sm btn-icon ml-8"
                  @click.prevent="resetEdit"
                >
                  <i class="fas fa-times text-red" />
                </button>
                <button
                  class="btn btn-outline-primary !tw-flex !tw-items-center !tw-justify-center btn-sm ml-8"
                  :disabled="isDisabledBtnComment || !comment"
                  @click.prevent="preloadImage"
                >
                  <img
                    :src="okImg"
                    alt=""
                    height="12"
                  >
                  <span class="ml-4">{{ $t('mediaBuying.campaign.send') }}</span>
                </button>
              </div>
            </div>
            <div class="form-group select-wrapper file-wrap file-wrap-comment mb-0 mt-0">
              <ElUpload
                :class="{
                  disabled: fileListComment.length 
                    === $store.state.mediaBuying.uploadSettingsData.max_files_per_request,
                }"
                class="upload-demo"
                action=""
                :on-remove="handleRemoveComment"
                :on-change="onSuccessComment"
                :file-list="fileListComment"
                :auto-upload="false"
                multiple
              >
                <button
                  class="btn btn-outline-primary btn-sm btn-icon"
                  @click.prevent
                >
                  <i class="fas fa-paperclip" />
                </button>
              </ElUpload>
              <span
                v-if="errorFile.length"
                class="error error-file text-danger !tw-text-left mt-2"
              >{{ errorFile[0] }}</span>
            </div>
          </div>
          <div class="statuses pay-info-wrap !tw-flex mb-4 mt-4 pt-10">
            <div class="select-wrapper mr-32">
              <UiLabel :label="$t('mediaBuying.payments.fields.moderation_status.title')" />
              <span v-html="formatStatus(form.moderation_status)" />
            </div>
            <div class="select-wrapper mr-32">
              <UiLabel :label="$t('mediaBuying.payments.fields.payout_status.title')" />
              <span v-html="formatStatus(form.payout_status)" />
            </div>
            <div class="select-wrapper">
              <UiLabel :label="$t('mediaBuying.campaign.request_date')" />
              <span>{{ $moment(form.created_at).format('DD MMM YYYY HH:mm') }}</span>
            </div>
          </div>
          <div class="select-wrapper select-wrapper-mob mb-8 mt-8">
            <UiLabel :label="$t('mediaBuying.campaign.payment_period')" />
            <span>{{ form.period }}</span>
          </div>
          <div class="pay-info-wrap !tw-flex mb-8">
            <div class="select-wrapper mr-32">
              <UiLabel :label="$t('mediaBuying.campaign.sum')" />
              <span>{{ currencyFormatter(form.currency_code, form.amount) }}</span>
            </div>
            <div class="select-wrapper mr-32">
              <UiLabel :label="$t('mediaBuying.campaign.payment_type')" />
              <span class="payment">
                <img
                  v-if="form.payment_method_logo_base64"
                  :src="form.payment_method_logo_base64"
                  :alt="form.payment_method_name"
                >
                <template v-else>{{ form.payment_method_name }}</template>
              </span>
            </div>
            <div class="select-wrapper">
              <UiLabel :label="$t('mediaBuying.campaign.wallet')" />
              <span class="wallet"> {{ form.payment_wallet }}</span>
            </div>
          </div>
          <div
            v-if="form.urls && form.urls.length && form.urls[0] !== '' && form.urls[0].url !== ''"
            class="select-wrapper urls-list mb-8"
          >
            <UiLabel label="URLs" />
            <div
              v-for="(url, key) in form.urls"
              :key="url.url + key"
              class="text-green"
            >
              <img
                :alt="form.platform_id"
                :src="iconPlatform.find(e => e.id === url.url_platform_id.toLowerCase()).logo_base64"
                class="mr-2"
              >
              <a
                :href="url.url"
                class="text-green"
                target="_blank"
              > {{ url.url }}</a>
            </div>
          </div>
          <div class="form-group select-wrapper mb-8">
            <UiLabel :label="$t('mediaBuying.campaign.description')" />
            <span class="white-space-pre">{{ form.description }}</span>
          </div>
          <div
            v-if="form.files && form.files.length"
            class="form-group select-wrapper file-wrap mb-0"
          >
            <UiLabel :label="$t('mediaBuying.campaign.files')" />
            <div class="file-wrap__images-wrap">
              <div
                v-for="(item, index) in form.files"
                :key="index"
                class="file-wrap__images-wrap-sub"
              >
                <span class="demonstration">{{ item.filename }}</span>
                <ElImage
                  v-if="item.preview_url"
                  :src="item.preview_url"
                  :preview-src-list="srcList"
                  :initial-index="srcList.indexOf(item.preview_url)"
                  :fit="'contain'"
                  :z-index="100002000"
                >
                  <template v-slot:error>
                    <div class="image-slot">
                      <i class="far fa-file" />
                      <a
                        :href="item.download_url"
                        :download="item.filename"
                        target="_blank"
                        @click.stop
                      >
                        <i class="fas fa-download" />
                      </a>
                    </div>
                  </template>
                </ElImage>
                <div
                  v-else
                  class="image-slot"
                >
                  <i class="far fa-file" />
                  <a
                    :href="item.download_url"
                    :download="item.filename"
                    target="_blank"
                  >
                    <i class="fas fa-download" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <template v-slot:footer>
        <div class="!tw-text-right !tw-flex !tw-items-baseline">
          <a
            class="btn btn-outline-primary btn-sm"
            @click="close"
          >
            {{ $t('paymentHistory.close') }}
          </a>
          <a
            v-if="form.moderation_status === 'for_rework' || form.payout_status === 'for_rework'"
            class="btn btn-primary btn-sm ml-16"
            :disabled="loading || undefined"
            @click="edit"
          >
            <span v-if="!loading">{{ $t('mediaBuying.campaign.edit') }}</span>
            <i
              v-if="loading"
              class="fas fa-spinner spinner-hide"
            />
          </a>
        </div>
      </template>
    </Modal>
    <RequestPayment
      id="ShowPayment"
      ref="requestPayment"
    />
  </section>
</template>

<script>
import { Modal } from '@/components';
import RequestPayment from '@/views/Dashboard/MediaBuying/Modal/RequestPayment.vue';
import formatCurrency from '@/mixins/format-currency';
import okImg from '@/assets/theme/icon/ok.svg';
import editMessages from './mixins/editMessages';

const classes = {
  approved: 'text-green',
  on_review: 'text-orange',
  declined: 'text-red',
  paid: 'text-green',
  processing: 'text-orange',
  not_paid: 'text-red',
  for_rework: 'text-red',
  failed: 'text-red',
};

export default {
  components: {
    Modal,
    RequestPayment,
  },
  mixins: [editMessages, formatCurrency],
  data() {
    return {
      fileListCommentBack: [],
      fileListComment: [],
      countFileComment: 0,
      comment: '',
      comments: [],
      formComment: {
        content: '',
        period: '',
        file_ids: [],
      },
      openImagePopup: [false],
      active: false,
      form: {},
      loading: false,
    };
  },
  computed: {
    okImg: () => okImg,
    srcList() {
      return this.form.files.filter((e) => e.preview_url !== null).map((e) => e.preview_url) || [];
    },
    currency() {
      return this.currencyFormatter(this.$store.state.mediaBuying.campaign.payments_currency_code);
    },
    iconPlatform() {
      return this.$store.state.misc.postPlatforms;
    },
  },
  methods: {
    open(row) {
      this.reset();
      this.form = this.$_.cloneDeep(row);
      this.form.period = `${this.$moment(row.payment_period_start).format('DD MMM YYYY HH:mm')} - ${this.$moment(row.payment_period_end).format('DD MMM YYYY HH:mm')}`;
      this.active = true;
      this.getCommentsPayment(row.id);
      this.fileList = row.files.map((e) => ({
        status: 'ready',
        name: e.filename,
        id: e.id,
      }));
    },
    close() {
      this.active = false;
      this.reset();
    },
    reset() {
      this.resetEdit();
      this.form.id = '';
      this.comments = [];
      this.fileListComment = [];
      this.errorFile = [];
      this.comment = '';
      this.formComment = {
        content: '',
        file_ids: [],
      };
    },
    edit() {
      this.active = false;
      this.$refs.requestPayment.open(this.form);
    },
    getComments() {
      this.getCommentsPayment(this.form.id);
    },
    postCommentsPayment(id) {
      this.formComment.content = this.comment;
      this.$store
        .dispatch('postPaymentComments', { id, ...this.formComment })
        .then(() => {
          this.comment = '';
          this.formComment = {
            content: '',
            file_ids: [],
          };
          this.getCommentsPayment(this.form.id);
        })
        .finally(() => {
          this.loading = false;
          this.isDisabledBtnComment = false;
        });
    },
    getCommentsPayment(id) {
      const [sort_column, sort_dir] = ['created_at', 'asc'];
      this.$store
        .dispatch('getPaymentComment', {
          id,
          sort_column,
          sort_dir,
        })
        .then((res) => {
          this.comments = res.payload;
          setTimeout(() => {
            const over = document.getElementsByClassName('comment-overflow')[0];
            if (over) over.scrollTop = 9999;
          }, 100);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatStatus(status) {
      return status && `<span class='${classes[status]}'>${this.$t(`mediaBuying.payments.status.${status}`)}</span>`;
    },
    currencyFormatter(code, amount) {
      if (!Number.isFinite(amount)) {
        return this.getCurrencyLabel(code);
      } else {
        amount = amount.toFixed(2);
        const amountData = amount.split('.');
        const result = (+amountData[0]).toLocaleString();

        return `${this.getCurrencyLabel(code)}${result}.${amountData[1]}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.media-buying-modal {
  .wallet {
    word-break: break-all;
  }
}

</style>
<style lang="scss">
.statuses {
  border-top: 1px solid #dee2e6;
}
</style>
